import { PhoneIncoming } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const ppcCtaSection: ServiceSection = {
  type: SECTION_TYPES.PPC_CTA,
  content: {
    header: "Book My Free Estimate",
    bgImage: {
      alt: "",
      providerId: "",
      source: "",
      url: "https://images.unsplash.com/photo-1592595896551-12b371d546d5?q=60&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3",
    },
  },
  meta: {
    displayName: "Call to Action PPC",
    displayDescription: "Get in touch with your customers.",
    displayIcon: PhoneIncoming,
  },
};

export default ppcCtaSection;
